var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"bg-gradient-to-b from-gray-100 to-white border-t border-gray-200"},[_c('div',{staticClass:"max-w-6xl mx-auto px-4 sm:px-6"},[_c('div',{staticClass:"py-12 md:py-16"},[_c('div',{staticClass:"max-w-3xl mx-auto text-center"},[_c('h2',{staticClass:"h2"},[_vm._v(" Step by step ")])])])])])
}]

export { render, staticRenderFns }